export default {
  projectDesc: '基于 <strong>Vue2</strong> 让文件上传更容易的插件<br>可拖拽文件或文件选择框中选择文件进行上传',
  useDialog: '实例中使用了 <a href="https://github.com/TerryZ/v-dialogs" target="_blank">v-dialogs</a> 来显示信息',
  demo: {
    title: '实例中仅返回同样的图片数据进行演示功能',
    single: '单文件上传模式',
    multiple: '批量文件上传模式',
    multipleSub: '设置选项 "multiple" 参数为 <code>true</code>',
    customSize: '单文件上传模式，自定义图片预览区域的尺寸',
    noPreview: '单文件上传模式，关闭图片预览区域，适用于非图片类型文件上传',
    uploadedInfo: '文件上传成功后的返回信息',
    buttonText: '单文件上传模式，自定义按钮文本',
    noIcon: '单文件上传模式，关闭按钮图标',
    customPreviewImage: '单文件上传模式，自定义图片预览区域的默认图片'
  },
  option: {
    multiple: '文件上传模式，在批量模式下，支持拖拽文件进行上传',
    language: '插件语言，目前仅提供 2 个语言可选择',
    fileSizeLimit: '上传文件的容量限制',
    fileTypeExts: '上传文件的类型限制（扩展名）',
    imageMaxHeight: '设置图片最大高度(像素), 设置 0 为不限制',
    imageMaxWidth: '设置图片最大宽度(像素), 设置 0 为不限制',
    imageMinHeight: '设置图片最小高度(像素), 设置 0 为不限制',
    imageMinWidth: '设置图片最小宽度(像素), 设置 0 为不限制',
    uploadFileUrl: '文件上传服务端地址',
    deleteFileUrl: '文件删除服务端地址',
    showMessage: '设置显示信息的方式，通常是文件上传失败之类的错误信息',
    preview: '预览已上传的图片文件',
    previewImg: '在图片预览框显示的默认图片',
    previewWidth: '图片预览框的宽度 (px)',
    previewHeight: '图片预览框的高度 (px)',
    buttonText: '上传按钮中显示的文本',
    buttonIcon: '上传按钮中显示图标',
    uploadFileObjName: '服务端接收文件流的对象名称',
    itemLimit: '批量上传模式中文件上传个数限制，设置 0 为不限制',
    beforeUpload: '自定义文件上传校验函数，当 return false 时，插件会阻止当前文件上传<br>' +
              '<strong>参数</strong>:<br>' +
              'id[number] - 当前上传文件的 id<br>' +
              'name[string] - 当前上传文件的 name'
  },
  event: {
    done: '在文件上传成功后，返回文件信息',
    doneArgs: '已上传文件信息'
  },
  server: {
    title: '服务端',
    request: {
      title: '接收数据',
      uploadFileObj: '接收上传文件的对象名',
      fileSizeLimit: '接收上传文件的容量限制',
      fileTypeExts: '接收上传文件的文件类型限制（后缀名）'
    },
    response: {
      title: '响应数据返回',
      desc: '文件上传和删除，返回同样格式的数据即可',
      success: '文件上传状态',
      error: '文件上传失败信息',
      url: '已上传文件可访问的全路径链接',
      example: '响应数据样例'
    }
  }
}
